const axios = require("axios");
axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

export default function InitMaps() {
	let mapElements = document.querySelectorAll(".google-maps-container");
	if (mapElements.length === 0) return;

	mapElements.forEach((mapElement) => {
		let map = initMap(mapElement);
		if (mapElement.getAttribute("data-draw-statuses") === "true") drawFiberStatuses(map);
	});
}

function initMap(mapElement) {
	let lat = Number(mapElement.getAttribute("data-center-latitude"));
	let lng = Number(mapElement.getAttribute("data-center-longitude"));

	return new google.maps.Map(mapElement, {
		zoomControl: true,
		mapTypeControl: false,
		scaleControl: true,
		streetViewControl: false,
		rotateControl: false,
		fullscreenControl: true,
		zoom: 15,
		scrollwheel: false,
		center: { lat: lat, lng: lng },
		styles: MapStyles,
	});
}

async function drawFiberStatuses(map) {
	const statuses = await fetch("/status/all").then((response) => response.json());
	const statusColors = await fetch("/status/colors").then((response) => response.json());

	if (statuses.length === 0) return;

	for (let [objectID, status] of Object.entries(statuses)) {
		let circle = new google.maps.Circle({
			strokeWeight: 0,
			fillColor: statusColors[status.statusID],
			fillOpacity: 1,
			radius: 8,
			map: map,
			center: status.coordinates,
		});
	}
}

const MapStyles = [
	{
		elementType: "geometry",
		stylers: [{ color: "#f5f5f5" }],
	},
	{
		elementType: "labels.icon",
		stylers: [{ visibility: "off" }],
	},
	{
		elementType: "labels.text.fill",
		stylers: [{ color: "#616161" }],
	},
	{
		elementType: "labels.text.stroke",
		stylers: [{ color: "#f5f5f5" }],
	},
	{
		featureType: "administrative.land_parcel",
		elementType: "labels.text.fill",
		stylers: [{ color: "#bdbdbd" }],
	},
	{
		featureType: "poi",
		elementType: "geometry",
		stylers: [{ color: "#eeeeee" }],
	},
	{
		featureType: "poi",
		elementType: "labels.text.fill",
		stylers: [{ color: "#757575" }],
	},
	{
		featureType: "poi.park",
		elementType: "geometry",
		stylers: [{ color: "#e5e5e5" }],
	},
	{
		featureType: "poi.park",
		elementType: "labels.text.fill",
		stylers: [{ color: "#9e9e9e" }],
	},
	{
		featureType: "road",
		elementType: "geometry",
		stylers: [{ color: "#ffffff" }],
	},
	{
		featureType: "road.arterial",
		elementType: "labels.text.fill",
		stylers: [{ color: "#757575" }],
	},
	{
		featureType: "road.highway",
		elementType: "geometry",
		stylers: [{ color: "#dadada" }],
	},
	{
		featureType: "road.highway",
		elementType: "labels.text.fill",
		stylers: [{ color: "#616161" }],
	},
	{
		featureType: "road.local",
		elementType: "labels.text.fill",
		stylers: [{ color: "#9e9e9e" }],
	},
	{
		featureType: "transit.line",
		elementType: "geometry",
		stylers: [{ color: "#e5e5e5" }],
	},
	{
		featureType: "transit.station",
		elementType: "geometry",
		stylers: [{ color: "#eeeeee" }],
	},
	{
		featureType: "water",
		elementType: "geometry",
		stylers: [{ color: "#c9c9c9" }],
	},
	{
		featureType: "water",
		elementType: "labels.text.fill",
		stylers: [{ color: "#9e9e9e" }],
	},
];
